import { Component } from '@angular/core';

@Component({
  selector: 'ap-panel-title',
  templateUrl: './panel-title.component.html',
  styleUrls: ['./panel-title.component.css']
})
export class PanelTitleComponent {

  constructor() { }

}
